// frontend gallery module
// exports are idempotent, the entry owns dom ready and the mutation observer,
// so nothing here wires up globals on import

const gallery = {
	init: function () {
		document.querySelectorAll( '.bpf-content--format-gallery' ).forEach(
			function ( holder ) {
				// init only once per holder, ajax loaded posts would double bullets and intervals
				if ( holder.dataset.bpfGallery ) {
					return;
				}

				holder.dataset.bpfGallery = 'done';

				// get no of items
				const noOfItems = gallery.getNoOfItems( holder );

				if ( ! noOfItems ) {
					return;
				}

				// generate pagination
				gallery.generatePagination( holder, noOfItems );

				// set initial active classes for first image
				gallery.setActiveClasses( holder, 0 );

				// play
				gallery.play( holder, noOfItems );

				// on mouse enter call pause method
				holder.addEventListener(
					'mouseenter',
					function () {
						gallery.pause( holder );
					}
				);

				// on mouse leave call play method
				holder.addEventListener(
					'mouseleave',
					function () {
						gallery.play( holder, noOfItems );
					}
				);

				// goto prev or next
				// find controls inside holder, list view renders more than one gallery
				[ 'prev', 'next' ].forEach(
					function ( direction ) {
						const control = holder.querySelector( '.bpf-content__gallery-' + direction );

						if ( ! control ) {
							return;
						}

						control.addEventListener(
							'click',
							function ( event ) {
								event.preventDefault();
								// call set new index method
								gallery.setNewIndex( holder, noOfItems, direction );
							}
						);
					}
				);

				// goto specific
				// must go after generate pagination
				holder.querySelectorAll( '.bpf-content__gallery-pagination li' ).forEach(
					function ( bullet, index ) {
						bullet.addEventListener(
							'click',
							function ( event ) {
								event.preventDefault();

								// call set active classes method if current bullet is not active
								if ( ! bullet.classList.contains( 'active' ) ) {
									gallery.setActiveClasses( holder, index );
								}
							}
						);
					}
				);
			}
		);
	},

	getNoOfItems: function ( holder ) {
		return holder.querySelectorAll( '.bpf-content__gallery-image' ).length;
	},

	generatePagination: function ( holder, noOfItems ) {
		const paginationHolder = holder.querySelector( '.bpf-content__gallery-pagination' );

		if ( ! paginationHolder ) {
			return;
		}

		while ( noOfItems-- ) {
			const bullet = document.createElement( 'li' );

			bullet.className = 'bpf-content__gallery-page';

			paginationHolder.appendChild( bullet );
		}
	},

	setActiveClasses: function ( holder, nextIndex ) {
		const images  = holder.querySelectorAll( '.bpf-content__gallery-image' ),
			bullets = holder.querySelectorAll( '.bpf-content__gallery-pagination li' );

		// remove active class from all
		images.forEach(
			function ( image ) {
				image.classList.remove( 'active' );
			}
		);

		bullets.forEach(
			function ( bullet ) {
				bullet.classList.remove( 'active' );
			}
		);

		// set active class to new
		if ( images[ nextIndex ] ) {
			images[ nextIndex ].classList.add( 'active' );
		}

		if ( bullets[ nextIndex ] ) {
			bullets[ nextIndex ].classList.add( 'active' );
		}
	},

	play: function ( holder, noOfItems ) {
		// call pause method, holder keeps its own interval
		gallery.pause( holder );

		holder.bpfInterval = setInterval(
			function () {
				// call set new index method
				gallery.setNewIndex( holder, noOfItems, 'next' );
			},
			3000
		);
	},

	setNewIndex: function ( holder, noOfItems, direction ) {
		const images       = holder.querySelectorAll( '.bpf-content__gallery-image' ),
			currentIndex = Array.prototype.indexOf.call( images, holder.querySelector( '.bpf-content__gallery-image.active' ) );

		let index = currentIndex;

		// set new index if prev
		if ( 'prev' === direction ) {
			index = ( 0 === currentIndex ) ? noOfItems - 1 : currentIndex - 1;
		}

		// set new index if next
		if ( 'next' === direction ) {
			index = ( noOfItems === currentIndex + 1 ) ? 0 : currentIndex + 1;
		}

		// call set active classes method
		gallery.setActiveClasses( holder, index );
	},

	pause: function ( holder ) {
		clearInterval( holder.bpfInterval );
	}
};

// set up any gallery that has not been handled yet
export function init() {
	gallery.init();
}
